import React, { useState } from 'react';
import { Button } from 'antd-mobile';
import './index.scss';
const Vh5Search = props => {
	let { searchData, searchCallback, onClose, placeholder, filterCallback, searchKey } = props;
	const [newData, setNewData] = useState(filterCallback(searchData) || []);
	function onInputChange(event) {
		let value = event.target.value;
		let _newData = searchData.filter(val => {
			return val.indexOf(value) >= 0;
		});
		if (filterCallback) {
			_newData = filterCallback(_newData);
			console.log(_newData);
		}
		setNewData(_newData);
	}
	return (
		<div className="vsearch-wrap">
			<b className="cancel" onClick={onClose}>
				取消
			</b>
			<div className="input-wrap">
				<input type="text" placeholder={placeholder || '请输入'} onChange={onInputChange} />
				{newData.length > 0 ? '' : <div className="nomatch">没有匹配城市</div>}
			</div>
			<ul className="city-list">
				{newData.map((v, index) => {
					return (
						<li key={searchKey + '-' + index} onClick={searchCallback.bind(this, v)}>
							{v}
						</li>
					);
				})}
			</ul>
		</div>
	);
};
export { Vh5Search };
